
import configurations from "@/mixins/configurations.js"
import { toNumber } from "~/helpers/helpers"

export default {
  mixins: [configurations],

  props: {
    root: {
      type: Object,
      required: true
    },

    product: {
      type: Object,
      required: true
    },

    parent: {
      type: Object,
      required: false
    },

    nested: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    showMsrpLine(item) {
      if (!this.__isMSRP) return false
      if (
        this.__isYourPrice &&
        !this.__getIsValidPrice(item.price) &&
        !this.__getIsValidPrice(item.msrpPrice) &&
        item.id !== -1
      )
        return false
      return true
    },

    getTooltipContent(configurationItem) {
      if (configurationItem.shortDescription) {
        return `
          <div>
            ${this.$options.filters.getCleanEMBSString(configurationItem.shortDescription)}
          </div>`
      }

      return null
    },

    getConfigurationItemIsDisabled(configurationItem) {
      return this.root.getListOfActiveConfigurations.some(
        (c) => configurationItem.intNote.includes(c.id) || c.intNote.includes(configurationItem.id)
      )
    },

    getConfigurationCanPrev(index, configuration) {
      return index > 0 || this.getConfigurationHasNestedItem(configuration)
    },

    // FIXME: do it via data, not DOM
    onPrev(index, configuration) {
      try {
        let container = this.$refs[`configuration--${configuration.name}`]

        if (Array.isArray(container) && container.length) {
          container = container[0]

          const btns = container.querySelectorAll(".js-configuration-remove")

          if (container.querySelector(".configuration--nested")) {
            this.__log("Has nested, remove last one")
            const lastBtn = btns[btns.length - 1]
            lastBtn.click()
          } else {
            if (index > 0) {
              // this.__log("No nested, come back");
              this.prev(index)
            } else {
              // this.__log("First configuration");
            }
          }
        }
      } catch (err) {
        console.log(err)
        this.__logError(err)
      }
    },

    toNumber(x) {
      return toNumber(x)
    }
  },

  created() {
    if (this.nested) {
      this.selectAllConfiguration()
      this.formatConfigurations()
      this.setDefaultConfigurations()
      this.getConfigurationRequiredPhotos()
    }
  }
}
